var React = require('react');

function Add (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17 9.5h-6.5V3h-1v6.5H3v1h6.5V17h1v-6.5H17z"}));
}

Add.defaultProps = {"viewBox":"0 0 20 20"};

module.exports = Add;

Add.default = Add;
